/* eslint-disable */
export default {
  forward: 'Desviar',
  cancel: 'Cancelar',
  customNumber: 'Número personalizado',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
